import {createAsyncThunk} from '@reduxjs/toolkit';
import {integrationsApi} from 'api';
import {IGetServiceEmailResponse} from 'models/integrations';
import {prefix} from './config';

export const fetchServiceEmailThunk: any = createAsyncThunk<IGetServiceEmailResponse, any>(
  `${prefix} fetchServiceEmail`,
  async (_, {dispatch, rejectWithValue}) => {
    try {
      const {parsedBody} = await integrationsApi.getServiceEmail();
      return parsedBody;
    } catch (error) {
      return rejectWithValue({error});
    }
  }
);
